var SearchModal = {
    id: "#searchModal",
    closeEvent: function () {

        var closeBtn = $(this.id).find('.close');

        closeBtn.on('click', function (e) {
            e.preventDefault();

            $(this).parents('.search-modal').hide();

            $('body').css('overflow-y', 'auto');
        });

    },
    openEvent: function () {

        var openBtnContainer = $('.header__search');
        var openBtn = openBtnContainer.find('.fa-search');
        var searchModal = $(this.id);

        openBtn.on('click', function (e) {
            e.preventDefault();

            $('html,body').scrollTop(0);
            
            searchModal.show();

            // set the body overflow-y to hidden
            $('body').css('overflow-y', 'hidden');
        });

    },
    init: function () {
        this.openEvent();
        this.closeEvent();
    }
};